/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isusergroupsyncenabled4Inputs */

const en_entity_isusergroupsyncenabled4 = /** @type {(inputs: Entity_Isusergroupsyncenabled4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Group Sync Enabled`)
};

const de_entity_isusergroupsyncenabled4 = /** @type {(inputs: Entity_Isusergroupsyncenabled4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzergruppensynchronisierung aktiviert`)
};

/**
* | output |
* | --- |
* | "Is User Group Sync Enabled" |
*
* @param {Entity_Isusergroupsyncenabled4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isusergroupsyncenabled4 = /** @type {((inputs?: Entity_Isusergroupsyncenabled4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isusergroupsyncenabled4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isusergroupsyncenabled4(inputs)
	return de_entity_isusergroupsyncenabled4(inputs)
});
export { entity_isusergroupsyncenabled4 as "entity_isUserGroupSyncEnabled" }